import * as React from 'react';

const ServiceUnavailableIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="480"
      height="280"
      viewBox="0 0 480 280"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="service-unavailable-illustration"
    >
      <path
        d="M397.864 242.173C400.051 238.015 398.863 232.768 396.141 228.925C393.418 225.082 389.399 222.343 385.467 219.69L380 216L382.611 228.846C383.493 233.189 384.579 237.879 388.04 240.726C390.803 242.947 394.549 243.594 397.921 242.432"
        fill="#E6E8E9"
      />
      <path
        d="M397.106 258.717C397.045 258.922 396.822 259.042 396.605 258.986C396.393 258.925 396.268 258.716 396.321 258.512C396.636 256.332 396.949 254.15 397.097 251.954C397.343 248.323 397.115 244.596 395.698 241.177C394.416 238.102 392.137 235.494 389.19 233.728C388.748 233.463 389.157 232.796 389.601 233.061C391.304 234.079 392.806 235.371 394.041 236.878C396.368 239.724 397.511 243.195 397.868 246.748C398.27 250.749 397.68 254.758 397.108 258.717L397.106 258.717Z"
        fill="#EBECED"
      />
      <path
        d="M343 233C358.278 244.143 353.185 259 353.185 259L343 233Z"
        fill="#E6E8E9"
      />
      <path
        d="M376 248.001C361.831 247.905 360 259 360 259L376 248.001Z"
        fill="#E6E8E9"
      />
      <path
        d="M36 259.5C36 259.224 36.2044 259 36.4565 259H423.544C423.796 259 424 259.224 424 259.5C424 259.776 423.796 260 423.544 260H36.4565C36.2044 260 36 259.776 36 259.5Z"
        fill="#181C1E"
      />
      <path
        d="M205.438 127.655C205.438 127.655 226.028 59.9482 232.645 59.0332C239.262 58.1183 249.923 76.4059 249.923 76.4059C263.746 93.8673 278 150.429 278 150.429C278 150.429 254.238 151.901 236.869 161.05C219.499 170.2 199 160.587 199 160.587L205.438 127.655Z"
        fill="#0F2658"
      />
      <path
        d="M284.419 146.752C287.723 147.67 291.192 145.971 292.493 142.796C293.794 139.621 292.516 135.974 289.518 134.308L275.151 118L263 120.627L280.091 137.375C279.24 139.178 279.232 141.265 280.067 143.074C280.902 144.884 282.496 146.231 284.419 146.752L284.419 146.752Z"
        fill="#A0616A"
      />
      <path
        d="M237 88.3942L273.02 133L284 128.027L241.662 63L237 88.3942Z"
        fill="#0F2658"
      />
      <circle cx="153" cy="256" r="4" fill="#0F2658" />
      <path
        d="M156.377 177.57C156.377 177.57 165.62 149.574 166.331 147.625C167.042 145.675 174.508 148.865 176.463 149.396C178.418 149.928 177.885 151.877 177.885 151.877L167.931 180.582L170.953 182L180.195 153.118C185.528 147.625 181.617 147.27 181.617 147.27C181.617 147.27 170.242 143.372 165.976 143.018C161.71 142.663 163.309 147.802 163.309 147.802L153 175.089L156.377 177.57Z"
        fill="#0F2658"
      />
      <path
        d="M178.07 182.477L178.068 182.475C176.761 180.604 174.906 179.184 172.758 178.41C172.682 178.381 172.593 178.349 172.492 178.314C167.615 176.611 133.63 167.446 133.63 167.446C133.63 167.446 126.902 164.97 123.892 171.69C120.882 178.41 103 234.114 103 234.114C103 234.114 137.975 252.795 148.171 254.829C148.8 254.98 149.45 255.032 150.096 254.981C151.829 254.741 153.535 254.334 155.189 253.766C157.019 253.17 158.76 252.33 160.365 251.267L180.194 192.026C180.194 192.026 183.027 185.483 178.07 182.477Z"
        fill="#2969F2"
      />
      <path
        d="M179.205 184.18L179.203 184.178C177.883 182.299 176.009 180.873 173.839 180.096C173.762 180.067 173.673 180.035 173.571 180C175.191 182.82 175.807 187.198 175.807 187.198C175.807 187.198 156.131 245.262 154.343 250.766C152.98 254.962 150.231 256.388 149 256.828C149.636 256.98 150.292 257.032 150.944 256.981C152.695 256.74 154.419 256.332 156.09 255.761C156.579 255.205 157.012 254.602 157.383 253.962C157.383 253.962 177.416 194.479 179.205 191.638C180.994 188.796 179.205 184.18 179.205 184.18Z"
        fill="#0F2658"
      />
      <circle cx="142" cy="256" r="4" fill="#0F2658" />
      <circle cx="104" cy="239" r="4" fill="#0F2658" />
      <path
        d="M172.726 149.687C169.488 150.709 165.996 149.155 164.596 146.069C163.197 142.983 164.333 139.341 167.241 137.591L180.883 121L193 123.163L176.678 140.286C177.583 142.034 177.665 144.092 176.903 145.907C176.14 147.721 174.61 149.105 172.726 149.687L172.726 149.687Z"
        fill="#A0616A"
      />
      <path
        d="M265 222.134L274 222L272.918 251H265.001L265 222.134Z"
        fill="#A0616A"
      />
      <path
        d="M264 249.001L278.658 249H278.659C283.818 249 288 253.336 288 258.684V258.999L264 259L264 249.001Z"
        fill="#202528"
      />
      <path
        d="M210.664 216L220 221.686L201.326 243L195 239.147L210.664 216Z"
        fill="#A0616A"
      />
      <path
        d="M194.249 236L206.673 243.888L206.674 243.889C211.046 246.665 212.315 252.421 209.508 256.746L209.342 257L189 244.085L194.249 236Z"
        fill="#202528"
      />
      <path
        d="M205.437 127.654C205.437 127.654 226.027 59.9479 232.645 59.0329C239.262 58.1179 247.215 76.5912 247.215 76.5912C254.103 104.778 278 150.429 278 150.429C278 150.429 254.238 151.901 236.869 161.05C219.499 170.2 199 160.587 199 160.587L205.437 127.654Z"
        fill="#040B2B"
      />
      <path
        d="M223.229 106.774V141.187L219.188 191.037L199 228.745L208.635 235.642L236.165 199.774L247.053 164.159L264.153 243L277 242.08L268.078 132.769L251.147 102L223.229 106.774Z"
        fill="#040B2B"
      />
      <path
        d="M243.201 74.5345C249.624 80.931 243.66 87.7845 243.66 87.7845L251 104.233L222.1 112L212 67.0513L218.881 59.741C232.643 59.2841 232.651 59 232.651 59C235.062 61.3502 243.201 74.5345 243.201 74.5345Z"
        fill="#D2D5D7"
      />
      <path
        d="M211.35 62.518C206.425 66.1359 204.91 72.8185 207.792 78.2033C211.094 84.4985 214.645 94.25 212.814 104.955C209.5 124.329 198.878 139.049 192.961 143.776C190.901 145.422 190.829 147.818 191.132 149.539C191.976 154.346 196.642 159.801 199.87 160.894C200.087 160.966 200.314 161.002 200.543 161C205.786 161.002 218.683 144.322 233.503 111.74C242.733 91.4485 236.034 75.1785 228.789 65.1026C226.868 62.4396 223.96 60.6554 220.714 60.1478C217.468 59.6402 214.153 60.4516 211.509 62.4009L211.35 62.518Z"
        fill="#0F2658"
      />
      <path
        d="M226 82.3167L184.062 137L173 132.419L212.64 66L226 82.3167Z"
        fill="#0F2658"
      />
      <path
        d="M238.716 52H209.284C208.023 51.9986 207.001 51.0083 207 49.7863V37.4882C206.997 31.5986 210.236 26.155 215.497 23.2093C220.759 20.2636 227.241 20.2636 232.503 23.2093C237.764 26.155 241.003 31.5986 241 37.4882V49.7863C240.999 51.0083 239.977 51.9986 238.716 52Z"
        fill="#040B2B"
      />
      <circle
        cx="226.517"
        cy="40.1133"
        r="12.1015"
        transform="rotate(-61.3368 226.517 40.1133)"
        fill="#A0616A"
      />
      <path
        d="M243 40H225.267L225.085 37.5484L224.176 40H221.446L221.085 35.141L219.283 40H214V39.7593C214.008 32.7158 219.936 27.008 227.25 27H229.75C237.064 27.0079 242.992 32.7158 243 39.7593L243 40Z"
        fill="#040B2B"
      />
      <path
        d="M225.698 55C225.561 54.9999 225.425 54.988 225.29 54.9645L212 52.6529V31H226.63L226.268 31.4163C221.228 37.2101 225.025 46.6049 227.737 51.6893C228.144 52.4492 228.074 53.3723 227.556 54.0639C227.125 54.6518 226.434 55 225.698 55Z"
        fill="#040B2B"
      />
    </svg>
  );
});

ServiceUnavailableIllustration.displayName = 'ServiceUnavailableIllustration';

export { ServiceUnavailableIllustration };
